<template>
  <div id="app">
    <b-loading
      v-model="isLoading"
      :is-full-page="true"
      :size="'is-small'" />
    <transition name="fade">
      <router-view class="router-view" />
    </transition>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'App',
    components: {},
    computed: {
      ...mapGetters({
        isLoading: 'isLoading',
      }),
    },
    mounted () {
      console.log('version:', '1.1.0')

      if (window.parent === window) {
        const parentOrigin = process.env.VUE_APP_PARENT_ORIGIN
        if (parentOrigin) {
          const currentPath = window.location.pathname + window.location.search + window.location.hash
          const redirectUrl = parentOrigin + currentPath
          window.location.href = redirectUrl
          return
        }
      }

      window.addEventListener('message', (event) => {
        if (event.data.type === 'redirect') {
          this.$router.push(event.data.url)
        }
      })

      if (window.parent !== window) {
        document.documentElement.classList.add('is-embedded')

        this.$router.afterEach((to) => {
          try {
            const url = window.location.origin + to.fullPath
            window.parent.postMessage(
              {
                type: 'url-change',
                url: url,
              },
              '*'
            )
          } catch (e) {
            console.error('Failed to send url-change message:', e)
          }
        })

        const handledKeys = new Set()

        window.addEventListener(
          'keydown',
          (event) => {
            const keyCombo = `${event.ctrlKey ? 'ctrl+' : ''}${
              event.metaKey ? 'meta+' : ''
            }${event.shiftKey ? 'shift+' : ''}${
              event.altKey ? 'alt+' : ''
            }${event.key.toLowerCase()}`
            handledKeys.add(keyCombo)

            setTimeout(() => {
              if (!event.defaultPrevented) {
                try {
                  window.parent.postMessage(
                    {
                      type: 'iframe-keydown',
                      key: event.key,
                      code: event.code,
                      ctrlKey: event.ctrlKey,
                      shiftKey: event.shiftKey,
                      altKey: event.altKey,
                      metaKey: event.metaKey,
                    },
                    '*'
                  )
                } catch (e) {
                  console.error(e)
                }
              }
              handledKeys.delete(keyCombo)
            }, 0)
          },
          true
        )
      }
    },
  }
</script>

<style lang="scss">
html {
  font-family: "DM Sans", sans-serif;
}

i {
  font-family: Material Icons;
  font-style: normal;
}
#app,
body,
html {
  height: 100%;
}

.modal {
  .modal-background {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal-card,
  .modal-content {
    max-height: min(calc(100vh - 40px), 90vh);
    margin: 20px auto;
    overflow: visible;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .modal-card-body {
    max-height: min(calc(100vh - 200px), calc(90vh - 160px));
    overflow-y: auto;
    flex: 1 1 auto;
    min-height: 0;
  }

  .modal-card-foot {
    flex-shrink: 0;
    position: sticky;
    bottom: 0;
    background: inherit;
  }
}

.dropdown-menu {
  max-height: min(calc(100vh - 100px), 600px);
  overflow-y: auto;
}

.dropdown-content {
  max-height: min(calc(100vh - 60px), 600px);
  overflow: visible;

  .modal-card {
    max-height: min(calc(100vh - 60px), 600px);
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .modal-card-body {
      max-height: min(calc(100vh - 180px), 480px);
      overflow-y: auto;
      flex: 1 1 auto;
      min-height: 0;
    }

    .modal-card-foot {
      flex-shrink: 0;
      position: sticky;
      bottom: 0;
      z-index: 10;
      background: inherit;
    }
  }
}

// html.is-embedded {
  // .dropdown-content {
  //   max-height: 500px;

  //   .modal-card {
  //     max-height: 500px;

  //     .modal-card-body {
  //       max-height: 380px;
  //     }
  //   }
  // }

  // .modal {
  //   .modal-card,
  //   .modal-content {
  //     max-height: 80vh;
  //   }

  //   .modal-card-body {
  //     max-height: calc(80vh - 160px);
  //   }
  // }

  // .dropdown-menu {
  //   max-height: 500px;
  // }
// }
</style>

<style lang="scss" scoped></style>
